import React from 'react';
import SectionHeader from './SectionHeader';
import MenuCard from './MenuCard';

const KitchenSection: React.FC = () => {
  const menuItems = [
    {
      image: '/images/food/steak-pie1.jpg',
      title: 'Homemade Steak Pie ',
      description: 'Signature Creamery Steak Pie, Tender chunks of slow cooked beef, Served with fresh vegetables',
      price: ''
    },
    {
      image: '/images/food/646896027_1515734050562150_5604057142649591045_n.jpg',
      title: 'Balmoral Burger',
      description: 'Two 100% Steak Burgers, Haggis, Onion rings, Chips & Chefs Peppercorn sauce',
      price: ''
    },
    {
      image: '/images/food/648129883_1518299026972319_4098804441019721444_n.jpg',
      title: 'Macaroni Cheese',
      description: 'Macaroni Pasta in our own cheese sauce, Served with Chips or Garlic Bread',
      price: ''
    }
  ];

  return (
    <section className="py-20 bg-primary-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="OUR KITCHEN"
          title="A Taste of The Creamery"
          subtitle="From hearty classics to elevated sharing plates — our kitchen fires all day, every day."
          darkMode={true}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {menuItems.map((item, index) => (
            <MenuCard
              key={index}
              image={item.image}
              title={item.title}
              description={item.description}
              price={item.price}
            />
          ))}
        </div>

        {/* Full Menu Button */}
        <div className="text-center mb-16">
          <a 
            href="/menu" 
            className="inline-block bg-primary-gold text-primary-black px-12 py-4 rounded-full font-semibold text-lg hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
          >
            View Full Menu
          </a>
        </div>

      </div>
    </section>
  );
};

export default KitchenSection;
